// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2KPVL","colCheckbox":"styles_colCheckbox__3wnYR"};